import { Routes } from '@angular/router';
import { ResetPasswordPage } from 'src/app/components/login-pages/reset-password/reset-password.page';
import { ChatComponent } from 'src/app/components/main-pages/chat/chat.component';
import { ErrorPageComponent } from 'src/app/components/main-pages/error-page/error-page.component';
import { ProjectsStatusComponent } from 'src/app/components/main-pages/projects/projects-status/projects-status.component';
import { ServiceConfigComponent } from 'src/app/components/main-pages/service-config/service-config.component';
import { SynthesisDashboardComponent } from 'src/app/components/main-pages/synthesis/shared/synthesis-dashboard/synthesis-dashboard.component';
import { SynthesisComponent } from 'src/app/components/main-pages/synthesis/synthesis.component';
import { TenantPickerComponent } from 'src/app/components/main-pages/synthesis/tenant-picker/tenant-picker.component';
import { AccessComponent } from 'src/app/components/main-pages/users/access/access.component';
import { EditUserComponent } from 'src/app/components/main-pages/users/edit-user/edit-user.component';
import { RegistryComponent } from 'src/app/components/main-pages/users/registry/registry.component';
import { WorkflowsMasterComponent } from 'src/app/components/main-pages/workflows/workflows-master/workflows-master.component';
import { ActionsComponent } from 'src/app/components/project-pages/actions/actions.component';
import { ProjectDashboardComponent } from 'src/app/components/project-pages/dashboard/personal-dashboard/personal-dashboard.component';
import { MapsComponent } from 'src/app/components/project-pages/dashboard/widgets/maps/maps.component';
import { TextComponent } from 'src/app/components/project-pages/dashboard/widgets/text/text.component';
import { WIDGET_REGISTRY } from 'src/app/components/project-pages/dashboard/widgets/widget-registry';
import { ImageMergingComponent } from 'src/app/components/project-pages/image-merging/image-merging.component';
import { PlanningComponent } from 'src/app/components/project-pages/planning/planning.component';
import { ReportComponent } from 'src/app/components/project-pages/report/report.component';
import { RiskComponent } from 'src/app/components/project-pages/risk/risk.component';
import { StreamComponent } from 'src/app/components/project-pages/stream/stream.component';
import { TimeLapseComponent } from 'src/app/components/project-pages/timelapse/timelapse.component';
import { InterventionsComponent } from 'src/app/components/project-settings/interventions/interventions.component';
import { CompaniesComponent } from 'src/app/components/main-pages/admin/companies/companies.component';
import { CompanyComponent } from 'src/app/components/main-pages/company/company.component';
import { LeaveGuard } from 'src/app/guards/leave.guard';
import { RoleGuard } from 'src/app/guards/role/role.guard';
import { TabGuard } from 'src/app/guards/tab/tab.guard';
import { HelpComponent } from 'ui-library';
import { LoginLayoutComponent } from './components/layouts/login-layout/login-layout.component';
import { MainLayoutComponent } from './components/layouts/main-layout/main-layout.component';
import { ProjectLayoutComponent } from './components/layouts/project-layout/project-layout.component';
import { ForgotPasswordComponent } from './components/login-pages/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login-pages/login/login.component';
import { DevicesComponent } from './components/main-pages/devices/devices.component';
import { TrackerConfigsComponent } from './components/main-pages/devices/tracker-configs/tracker-configs.component';
import { ContactUsComponent } from './components/main-pages/help/contact-us/contact-us.component';
import { ProfileComponent } from './components/main-pages/profile/profile.component';
import { AddProjectComponent } from './components/main-pages/projects/add-project/add-project.component';
import { ProjectsComponent } from './components/main-pages/projects/projects.component';
import { DashboardComponent } from './components/project-pages/dashboard/dashboard.component';
import { PlanningsComponent } from './components/project-pages/plannings/plannings.component';
import { RisksComponent } from './components/project-pages/risks/risks.component';
import { ViewerForgeComponent } from './components/project-pages/viewer-forge/viewer-forge.component';
import { ViewerMapsComponent } from './components/project-pages/viewer-maps/viewer-maps.component';
import { DatabaseComponent } from './components/project-settings/database/database.component';
import { InformationComponent } from './components/project-settings/information/information.component';
import { KydComponent } from './components/project-settings/kyd/kyd.component';
import { ModelsComponent } from './components/project-settings/models/models.component';
import { ProjectSettingsComponent } from './components/project-settings/project-settings.component';
import { ResourcesComponent } from './components/project-settings/resources/resources.component';
import { SecurityComponent } from './components/project-settings/security/security.component';
import { TagsComponent } from './components/project-settings/tags/tags.component';
import { UsersComponent } from './components/project-settings/users/users.component';
import { WorkflowsComponent } from './components/project-settings/workflows/workflows.component';
import { AuthGuard } from './guards/auth/auth.guard';
import { loginPageGuard } from './guards/auth/login-page.guard';

export const routes: Routes = [

  // Project-pages
  {
    path: 'project',
    title: 'Unifield',
    component: ProjectLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        title: 'Unifield | Dashboard',
        component: DashboardComponent,
      },
      {
        path: 'dashboard',
        title: 'Unifield | Dashboard',
        component: DashboardComponent,
      },
      {
        path: 'workflows',
        title: 'Unifield | Workflows',
        component: WorkflowsComponent,
        canActivate: [RoleGuard, TabGuard],
        data: { minimumRole: 'user', tab: 'workflows', tabType: 'setting' }
      },
      {
        path: 'viewer/forge',
        title: 'Unifield | Viewer Forge',
        component: ViewerForgeComponent,
        canActivate: [TabGuard],
        data: { tab: 'viewer/forge' }
      },
      {
        path: 'viewer/maps',
        title: 'Unifield | Viewer Maps',
        component: ViewerMapsComponent,
        canActivate: [TabGuard],
        data: { tab: 'viewer/maps' }
      },
      {
        path: 'plannings',
        title: 'Unifield | Plannings ',
        component: PlanningsComponent,
        canActivate: [TabGuard],
        data: { tab: 'plannings' }
      },
      {
        path: 'image-merging',
        title: 'Unifield | Image Merging',
        component: ImageMergingComponent,
      },
      {
        path: 'planning',
        canActivate: [AuthGuard],
        title: 'Unifield | Planning',
        component: PlanningComponent
      },
      {
        path: 'report',
        title: 'Unifield | Report',
        component: ReportComponent,
        canActivate: [TabGuard],
        data: { tab: 'report' }
      },
      {
        path: 'risks',
        title: 'Unifield | Risks',
        component: RisksComponent,
        canActivate: [TabGuard],
        data: { tab: 'risks' }
      },
      {
        path: 'risk/:id',
        title: 'Unifield | Risk',
        component: RiskComponent,
        canActivate: [TabGuard],
        data: { tab: 'risks' }
      },
      {
        path: 'actions',
        title: 'Unifield | Actions',
        component: ActionsComponent,
        canActivate: [TabGuard],
        data: { tab: 'actions' }
      },
      {
        path: 'interventions',
        title: 'Unifield | Interventions',
        component: InterventionsComponent,
        canActivate: [RoleGuard],
        data: { minimumRole: 'admin' }
      },
      {
        path: 'stream',
        title: 'Unifield | Stream',
        component: StreamComponent,
        canActivate: [TabGuard],
        data: { tab: 'stream' },
        canDeactivate: [LeaveGuard]
      },
      {
        path: 'project-settings',
        title: 'Unifield | Project settings',
        component: ProjectSettingsComponent,
        children: [
          {
            path: 'informations',
            title: 'Unifield | Project settings',
            component: InformationComponent,
            canActivate: [TabGuard],
            data: { tab: 'informations', tabType: 'setting' }
          },
          {
            path: 'resources',
            title: 'Unifield | Project resources',
            component: ResourcesComponent,
            canActivate: [TabGuard],
            data: { tab: 'project-settings/resources', tabType: 'setting' }
          },
          {
            path: 'models',
            title: 'Unifield | Project settings',
            component: ModelsComponent,
            canActivate: [TabGuard],
            data: { tab: 'models', tabType: 'setting' }
          },
          {
            path: 'users',
            title: 'Unifield | Project users',
            component: UsersComponent,
            canActivate: [TabGuard],
            data: { tab: 'project-settings/users', tabType: 'setting' }
          },
          {
            path: 'security',
            title: 'Unifield | Project settings',
            component: SecurityComponent,
            canActivate: [TabGuard],
            data: { tab: 'project-settings/security', tabType: 'setting' }
          },
          {
            path: 'database',
            title: 'Unifield | Project settings',
            component: DatabaseComponent,
            canActivate: [TabGuard],
            data: { tab: 'project-settings/database', tabType: 'setting' }
          },
          {
            path: 'kyd',
            title: 'Unifield | Project settings',
            component: KydComponent,
            canActivate: [TabGuard],
            data: { tab: 'project-settings/kyd', tabType: 'setting' }
          },
          {
            path: 'tags',
            title: 'Unifield | Project settings',
            component: TagsComponent,
            canActivate: [TabGuard],
            data: { tab: 'project-settings/tags', tabType: 'setting' }
          },
        ]
      },
      {
        path: 'help',
        title: 'Unifield | Help',
        component: HelpComponent,
      },
      {
        path: 'timelapse',
        title: 'Unifield | TimeLapse',
        component: TimeLapseComponent,
        canActivate: [TabGuard],
        data: { tab: 'timelapse' }
      },
    ],
  },

  // Project-pages
  {
    path: '',
    title: 'Unifield',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        title: 'Unifield | Projects',
        component: ProjectsComponent,
      },
      {
        path: 'projects',
        title: 'Unifield | Projects',
        component: ProjectsComponent,
      },
      {
        path: 'project-detail',
        title: 'Unifield | Add project',
        component: AddProjectComponent,
        canActivate: [RoleGuard],
        data: { minimumRole: 'userAdmin' }
      },
      {
        path: 'projects-status',
        title: 'Unifield | Projects status',
        component: ProjectsStatusComponent,
        canActivate: [RoleGuard],
        data: { minimumRole: 'user' }
      },
      {
        path: 'project-dashboard',
        title: 'Unifield | Project Dashboard',
        component: ProjectDashboardComponent
      },
      {
        path: 'devices',
        title: 'Unifield | Devices',
        component: DevicesComponent,
        canActivate: [RoleGuard],
        data: { minimumRole: 'user' }
      },
      {
        path: 'devices/configs',
        title: 'Unifield | Device configs',
        component: TrackerConfigsComponent,
        canActivate: [RoleGuard],
        data: { minimumRole: 'user' }
      },
      {
        path: 'users',
        title: 'Unifield | Users',
        children: [
          {
            path: 'accesses',
            title: 'Unifield | Edit User',
            component: AccessComponent,
            canActivate: [RoleGuard],
            data: { minimumRole: 'admin' }
          },
          {
            path: 'registry',
            title: 'Unifield | Edit User',
            component: RegistryComponent,
            canActivate: [RoleGuard],
            data: { minimumRole: 'userAdmin' }
          },
          {
            path: 'edit-user',
            title: 'Unifield | Edit User',
            component: EditUserComponent,
            canActivate: [RoleGuard],
            data: { minimumRole: 'userAdmin' }
          },
        ]
      },
      {
        path: 'help',
        title: 'Unifield | Help',
        component: HelpComponent,
      },
      {
        path: 'profile',
        title: 'Unifield | Profile',
        component: ProfileComponent,
      },
      {
        path: 'company',
        title: 'Unifield | Compagnie',
        component: CompanyComponent,
      },
      {
        path: 'company/:id',
        title: 'Unifield | Compagnie',
        component: CompanyComponent,
      },
      {
        path: 'contact-us',
        title: 'Unifield | Contact Us',
        component: ContactUsComponent,
      },
      {
        path: 'chat',
        title: 'Unifield | Chat',
        component: ChatComponent,
        canActivate: [RoleGuard],
        data: { minimumRole: 'user' }
      },
      {
        path: "workflows-master",
        title: 'Unifield | Workflows Master',
        component: WorkflowsMasterComponent,
        canActivate: [RoleGuard],
        data: { minimumRole: 'admin' }
      },
      {
        path: 'admin',
        title: 'Unifield | Admin',
        children: [
          {
            path: 'all-interventions',
            title: 'Unifield | Interventions',
            component: InterventionsComponent,
            canActivate: [RoleGuard],
            data: { minimumRole: 'admin', adminMode: true }
          },
          {
            path: 'companies',
            title: 'Unifield | Compagnies',
            component: CompaniesComponent,
            canActivate: [RoleGuard],
            data: { minimumRole: 'admin' }
          },
        ]
      },
      {
        path: 'service-config',
        title: 'Unifield | Configuration des Services',
        component: ServiceConfigComponent,
        canActivate: [RoleGuard],
        data: { minimumRole: 'admin' }
      },

      // Synthèses entreprise (tous les projets enfants du tenant)
      {
        path: 'synthesis',
        title: 'Unifield | Synthèses',
        component: TenantPickerComponent,
      },
      {
        path: 'synthesis/:tenantId',
        title: 'Unifield | Synthèses',
        component: SynthesisComponent,
        children: [
          {
            path: '',
            redirectTo: 'prevention',
            pathMatch: 'full'
          },
          {
            path: 'prevention',
            title: 'Unifield | Synthèse Prévention',
            component: SynthesisDashboardComponent,
          },
          {
            path: 'production',
            title: 'Unifield | Synthèse Production',
            component: SynthesisDashboardComponent,
          },
          {
            path: 'safety',
            title: 'Unifield | Synthèse Sécurité',
            component: SynthesisDashboardComponent,
          },
          {
            path: 'environment',
            title: 'Unifield | Synthèse Environnement',
            component: SynthesisDashboardComponent,
          },
        ]
      },

      // Route 403 - Accès refusé
      {
        path: 'forbidden',
        title: 'Unifield | Accès refusé',
        component: ErrorPageComponent,
        data: { icon: 'lock', message: 'page.access_denied', description: 'page.access_forbidden' }
      },
    ],
  },
  {
    path: 'login',
    title: 'Unifield | Login',
    component: LoginComponent,
  },
  {
    path: 'reset-password',
    title: 'Unifield | Reset password ',
    component: ResetPasswordPage,
  },
  {
    path: "embed",
    children: [
      {
        path: "dashboard",
        component: DashboardComponent
      },
      // Every widget type (reports capture /embed/<type>), plus former aliases.
      ...Object.entries(WIDGET_REGISTRY).map(([path, { component }]) => ({ path, component })),
      {
        path: "text",
        component: TextComponent
      },
      {
        path: "maps",
        component: MapsComponent
      },
      {
        path: "viewer-maps",
        component: ViewerMapsComponent
      },
      {
        path: "viewer-forge",
        component: ViewerForgeComponent
      },
      {
        path: "risk",
        component: RiskComponent
      }
    ]
  },
  {
    path: 'auth',
    title: 'Unifield | Login',
    component: LoginLayoutComponent,
    // OIDC: these pages are auth-api's.
    canActivate: [loginPageGuard],
    children: [
      {
        path: '',
        title: 'Unifield | Login',
        component: LoginComponent,
      },
      {
        path: 'login',
        title: 'Unifield | Login',
        component: LoginComponent,
      },
      {
        path: 'auth',
        title: 'Unifield | Login',
        component: LoginComponent,
      },
      {
        path: 'callback',
        title: 'Unifield | Login',
        component: LoginComponent,
      },
      {
        // Same SSO callback as 'callback', but used as the `returnTo` target when the
        // login was started from the mobile app's in-app system browser (which can't
        // register its own returnTo with auth-api). Immediately relays the result into
        // the app via its custom URL scheme instead of completing the login in-page.
        path: 'callback-mobile',
        title: 'Unifield | Login',
        component: LoginComponent,
        data: { mobileRelay: true },
      },
      {
        path: 'reset-password',
        title: 'Unifield | Reset password ',
        component: ResetPasswordPage,
      },
      {
        path: 'forgot-password',
        title: 'Unifield | Forgot password ',
        component: ForgotPasswordComponent,
      },
      {
        path: 'contact-us',
        title: 'Unifield | Contact us',
        component: ContactUsComponent,
      },
    ],
  }
  // {
  //   path: '**',
  //   title: 'Unifield | Page non trouvée',
  //   component: ErrorPageComponent,
  //   data: { icon: 'search_off', message: 'page.not_found', description: 'page.not_found_description' }
  // }
];
